import { ReactNode } from 'react';

import {
    BannerAnchor,
    BannerContainer,
    BannerDescription,
    BannerLink,
    BannerList,
    BannerListItem,
    BannerTitle,
} from './LoginBanner.styled';

interface LoginBannerProps {
    children: ReactNode;
    className?: string;
}

export const LoginBanner = ({ children, className }: LoginBannerProps) => {
    return <BannerContainer className={className}>{children}</BannerContainer>;
};

LoginBanner.Description = BannerDescription;
LoginBanner.Link = BannerLink;
LoginBanner.List = BannerList;
LoginBanner.ListItem = BannerListItem;
LoginBanner.Title = BannerTitle;
LoginBanner.Anchor = BannerAnchor;
